const th = {
  seo: {
    title: "สแกน QR Code จากรูปออนไลน์ฟรี | QRCode GEN",
    description:
      "อัปโหลดรูปหรือภาพหน้าจอเพื่อสแกน QR Code ออนไลน์ อ่านข้อมูล เปิดลิงก์ และดูวิธีสแกนบน iPhone, Android และ LINE ได้ในหน้าเดียว",
    keywords:
      "สแกน QR Code จากรูป, สแกนคิวอาร์โค้ดออนไลน์, อ่าน QR Code จากภาพ, สแกน QR Code ในคอม, สแกน QR Code iPhone, สแกน QR Code Android"
  },
  ui: {
    home: "หน้าแรก",
    highlights: "จุดเด่น",
    idleTitle: "ผลการสแกนจะแสดงตรงนี้",
    idleDescription: "เลือกรูปเพื่อเริ่มอ่านข้อมูลใน QR Code",
    errorTitle: "ยังอ่าน QR Code ไม่ได้",
    backToScanner: "กลับไปที่เครื่องมือสแกน ↑",
    faqEyebrow: "คำถามที่พบบ่อย"
  },
  breadcrumb: "สแกน QR Code ออนไลน์",
  eyebrow: "เครื่องมืออ่าน QR Code จากรูป",
  title: "สแกน QR Code จากรูปออนไลน์",
  intro:
    "สแกน QR Code จากรูปหรือกล้อง. ผลลัพธ์จะแสดงในหน้าต่างป๊อปอัป คุณสามารถคัดลอกข้อมูลหรือกดเปิดลิงก์สำหรับ URL แบบ HTTP/HTTPS ที่ถูกต้อง",
  benefits: [
    "ไม่ต้องติดตั้งแอปสแกนเพิ่ม",
    "รูปถูกประมวลผลบนอุปกรณ์",
    "ข้อมูลใน QR Code"
  ],
  tool: {
    title: "อัปโหลดรูปที่มี QR Code",
    description:
      "ใช้ไฟล์ต้นฉบับหรือภาพหน้าจอที่คมชัด เห็น QR Code ครบทั้งสี่ด้านและมีพื้นที่ว่างรอบโค้ด",
    dropTitle: "ลากรูป QR Code มาวางตรงนี้",
    dropActiveTitle: "ปล่อยรูปเพื่อเริ่มสแกน",
    dropDescription: "หรือเลือกรูปจากโทรศัพท์หรือคอมพิวเตอร์",
    chooseFile: "เลือกรูป",
    fileHint: "รองรับ PNG, JPG, JPEG และ WebP · ไม่เกิน 12 MB",
    privacy:
      "รูปถูกอ่านในเบราว์เซอร์นี้โดยตรงและไม่ถูกส่งไปยังเซิร์ฟเวอร์ของ QRCode GEN",
    processing: "กำลังอ่าน QR Code…",
    resultTitle: "ข้อมูลใน QR Code",
    resultType: "ประเภทข้อมูล",
    copy: "คัดลอก",
    copied: "คัดลอกแล้ว",
    openLink: "เปิดลิงก์",
    scanAnother: "สแกนรูปอื่น",
    previewAlt: "รูป QR Code ที่เลือก",
    idleTabTitle: "กำลังอ่าน QR Code…",
    idleTabMessage: "กำลังอ่านข้อมูลใน QR Code…",
    noResult:
      "ไม่พบ QR Code ในรูป ลองใช้ภาพที่คมชัดขึ้น เห็นโค้ดครบทุกด้านและไม่ตัดพื้นที่ว่างรอบโค้ด",
    invalidType: "โปรดเลือกไฟล์ PNG, JPG, JPEG หรือ WebP",
    tooLarge: "รูปมีขนาดเกิน 12 MB โปรดลดขนาดไฟล์แล้วลองอีกครั้ง",
    imageError: "เปิดรูปนี้ไม่ได้ ลองบันทึกเป็น PNG หรือ JPG แล้วอัปโหลดใหม่",
    copyError: "คัดลอกอัตโนมัติไม่ได้ โปรดเลือกและคัดลอกข้อมูลด้านล่าง",
    safety:
      "ตรวจชื่อโดเมนก่อนกรอกรหัสผ่าน OTP หรือข้อมูลการชำระเงิน เพราะ QRCode GEN ไม่ได้ตรวจสอบความปลอดภัยของเว็บไซต์ปลายทาง",
    types: {
      url: "ลิงก์เว็บไซต์",
      wifi: "ข้อมูล Wi-Fi",
      email: "อีเมล",
      phone: "หมายเลขโทรศัพท์",
      sms: "ข้อความ SMS",
      vcard: "ข้อมูลติดต่อ vCard",
      payment: "ข้อมูลการชำระเงิน",
      text: "ข้อความ"
    }
  },
  onlineGuide: {
    eyebrow: "สแกนบน QRCode GEN ได้ทันที",
    title: "วิธีสแกน QR Code จากไฟล์รูป",
    intro:
      "เหมาะกับ QR Code ที่อยู่ในภาพหน้าจอ อีเมล เอกสาร หรือกำลังแสดงอยู่บนอุปกรณ์เครื่องเดียวกับที่ใช้งาน",
    visual: {
      alt: "ภาพแสดงขั้นตอนอัปโหลดรูป อ่าน QR Code ในเบราว์เซอร์ และดูผลลัพธ์",
      source: "รูป QR Code",
      process: "อ่านในเบราว์เซอร์",
      result: "ดูผลลัพธ์"
    },
    steps: [
      {
        number: "01",
        title: "เตรียมรูปที่คมชัดและเห็นโค้ดครบ",
        description:
          "ควรเห็นกรอบสี่เหลี่ยมใหญ่ทั้งสามมุมและพื้นที่ว่างรอบ QR Code หลีกเลี่ยงภาพเบลอหรือภาพที่ถูกบีบอัดมาก"
      },
      {
        number: "02",
        title: "ลากรูปมาวางหรือเลือกไฟล์",
        description:
          "ใส่รูปในเครื่องมือด้านบน ระบบอ่านภาพในเบราว์เซอร์ จึงไม่ต้องเปิดกล้องหรือติดตั้งแอปเพิ่ม"
      },
      {
        number: "03",
        title: "ดูข้อมูลที่อ่านได้",
        description:
          "ผลลัพธ์จะแสดงในหน้าต่างป๊อปอัป คุณสามารถคัดลอกข้อมูลหรือกดเปิดลิงก์สำหรับ URL แบบ HTTP/HTTPS ที่ถูกต้อง"
      },
      {
        number: "04",
        title: "คัดลอกผลลัพธ์หรือสแกนรูปใหม่",
        description:
          "คัดลอกข้อมูลไปใช้ หรือ ตรวจสอบที่อยู่แล้วกดเปิดลิงก์ ปิดหน้าต่างผลลัพธ์เพื่อกลับไปสแกนต่อ"
      }
    ]
  },
  deviceGuides: [
    {
      id: "scan-qr-code-iphone",
      icon: "mobile",
      eyebrow: "iOS · iPhone และ iPad",
      title: "วิธีสแกน QR Code บน iPhone",
      description:
        "ใช้แอปกล้องหรือเครื่องสแกนโค้ดในศูนย์ควบคุมได้โดยไม่ต้องลงแอปเพิ่มเติม",
      steps: [
        "เปิดแอปกล้องจากหน้าจอโฮม หน้าจอล็อก หรือศูนย์ควบคุม",
        "ใช้โหมดรูปภาพและจัดให้ QR Code อยู่ในกรอบครบทั้งโค้ด",
        "รอให้ลิงก์หรือการแจ้งเตือนปรากฏ แล้วแตะเพื่อเปิดข้อมูล",
        "หากไม่พบเครื่องสแกนโค้ด ให้เพิ่มเมนูสแกนโค้ดไว้ในศูนย์ควบคุม"
      ],
      note:
        "ถ้า QR Code อยู่ในรูปบน iPhone เครื่องเดียวกัน อัปโหลดรูปในเครื่องมือด้านบนได้โดยไม่ต้องใช้โทรศัพท์อีกเครื่อง",
      visual: {
        type: "iphone",
        alt: "iPhone ใช้กล้องตรวจพบ QR Code และแสดงลิงก์",
        app: "กล้อง",
        status: "พบลิงก์แล้ว",
        caption: "ให้ QR Code อยู่ในกรอบครบ แล้วแตะลิงก์ที่ปรากฏบนหน้าจอ"
      }
    },
    {
      id: "scan-qr-code-android",
      icon: "globe",
      eyebrow: "Android",
      title: "วิธีสแกน QR Code บนโทรศัพท์ Android",
      description:
        "ตำแหน่งเมนูสแกนอาจต่างกันตามยี่ห้อโทรศัพท์ เวอร์ชัน Android และแอปกล้อง",
      steps: [
        "เปิดกล้องในโหมดรูปภาพแล้วหันไปที่ QR Code หากมีแถบแจ้งเตือนให้แตะเพื่อเปิด",
        "ถ้ากล้องไม่ตรวจพบ ให้เปิด Google Lens จากกล้อง Google Photos หรือแอป Google",
        "บน Samsung Galaxy ลองใช้กล้องหรือปุ่ม Scan QR code ในแผงการตั้งค่าด่วน บางรุ่นต้องเปิดฟังก์ชันนี้ในตั้งค่ากล้อง",
        "ถ้าโค้ดอยู่ในรูปที่บันทึกไว้ ให้เปิดด้วย Gallery หรือ Google Photos แล้วใช้ Lens หรืออัปโหลดรูปที่หน้านี้"
      ],
      note:
        "Camera from Google รองรับการสแกน QR เฉพาะอุปกรณ์บางรุ่น ชื่อเมนูและตำแหน่งปุ่มอาจไม่เหมือนกัน",
      visual: {
        type: "android",
        alt: "โทรศัพท์ Android ใช้ Google Lens สแกน QR Code",
        app: "Google Lens",
        status: "แตะเพื่อเปิด",
        caption: "หากกล้องปกติอ่านไม่ได้ ให้ลอง Lens หรือเครื่องสแกน QR ที่มากับโทรศัพท์"
      }
    },
    {
      id: "scan-qr-code-social-apps",
      icon: "message",
      eyebrow: "แอปแชต โซเชียล และธนาคาร",
      title: "สแกน QR Code ด้วย LINE และแอปอื่น",
      description:
        "หลายแอปมีเครื่องสแกนในตัว แต่แต่ละแอปอาจรองรับ QR Code คนละประเภท",
      steps: [
        "LINE ใช้สแกนบัญชี LINE ลิงก์เว็บไซต์ ข้อความ และ QR Code ทั่วไปบางประเภทได้",
        "ในหน้าสแกนของ LINE แตะไอคอนรูปภาพเพื่ออ่าน QR Code จากรูปที่บันทึกไว้",
        "เครื่องสแกนในแอปโซเชียลมักเน้นโค้ดโปรไฟล์ การเข้าสู่ระบบ หรือการแชร์ของแพลตฟอร์มนั้น",
        "QR ชำระเงินและ PromptPay ควรสแกนด้วยแอปธนาคารที่รองรับเพื่อดูชื่อผู้รับและยอดเงินก่อนยืนยัน"
      ],
      note:
        "ถ้าแอปหนึ่งอ่านไม่ได้ ไม่ได้หมายความว่าโค้ดเสีย ลองใช้กล้อง Google Lens หรือเครื่องมืออัปโหลดด้านบน",
      visual: {
        type: "social",
        alt: "เครื่องสแกน QR Code ใน LINE แอปโซเชียล และแอปธนาคาร",
        app: "เครื่องสแกนในแอป",
        status: "เลือกแอปให้ตรงกับประเภทโค้ด",
        labels: ["LINE", "โซเชียล", "ธนาคาร"],
        caption: "แต่ละแอปอาจรองรับ QR Code เพียงบางประเภท"
      }
    },
    {
      id: "other-qr-code-scanners",
      icon: "qrcode",
      eyebrow: "วิธีสแกนแบบอื่น",
      title: "ทำอย่างไรเมื่อกล้องสแกน QR Code ไม่ได้",
      description:
        "ลองใช้เครื่องมือที่มีในโทรศัพท์ก่อนติดตั้งแอปสแกนที่ไม่คุ้นเคย",
      steps: [
        "เปิด QR Code บนหน้าจอหนึ่ง แล้วใช้กล้องของโทรศัพท์อีกเครื่องสแกน",
        "บันทึกภาพหรือจับภาพหน้าจอ แล้วอัปโหลดเข้า QRCode GEN จากโทรศัพท์หรือคอมพิวเตอร์",
        "ใช้ Google Lens หรือฟังก์ชันอ่าน QR ที่มีอยู่ในแกลเลอรีรูป",
        "หากต้องลงแอปเพิ่ม ให้ดาวน์โหลดจากร้านค้าอย่างเป็นทางการและตรวจสิทธิ์ที่แอปร้องขอ"
      ],
      note:
        "เครื่องอ่านบาร์โค้ดหน้าร้านต้องรองรับโค้ดแบบ 2D อุปกรณ์ที่อ่านได้เฉพาะบาร์โค้ด 1D จะอ่าน QR Code ไม่ได้",
      visual: {
        type: "alternatives",
        alt: "อัปโหลดรูป QR Code ที่บันทึกไว้เพื่ออ่านบนคอมพิวเตอร์",
        app: "รูปที่บันทึกไว้",
        status: "ข้อมูลใน QR Code",
        caption: "บันทึกรูปหรือภาพหน้าจอที่ชัด แล้วอัปโหลดในเครื่องมือด้านบน"
      }
    }
  ],
  troubleshooting: {
    eyebrow: "อ่านรูปไม่ได้?",
    title: "สาเหตุที่สแกน QR Code จากรูปไม่สำเร็จ",
    items: [
      {
        title: "รูปตัดขอบหรือพื้นที่ว่างรอบโค้ด",
        description:
          "ใช้รูปที่เห็นโค้ดครบ กรอบสี่เหลี่ยมใหญ่ทั้งสามมุมและพื้นหลังสว่างรอบโค้ดต้องไม่หายไป"
      },
      {
        title: "QR Code เล็กเกินไปในภาพหน้าจอขนาดใหญ่",
        description:
          "ตัดส่วนที่ไม่เกี่ยวข้องออกโดยไม่ตัดโดนตัวโค้ด แล้วบันทึกรูปด้วยคุณภาพสูง"
      },
      {
        title: "ภาพเบลอ ถูกบีบอัด หรือมีแสงสะท้อน",
        description:
          "ลองใช้ไฟล์ต้นฉบับ ถ่ายใกล้ขึ้น หรือเพิ่มความสว่างหน้าจอเมื่อถ่ายจากอุปกรณ์อีกเครื่อง"
      },
      {
        title: "ลาย QR Code แน่นเกินไปเมื่อเทียบกับขนาด",
        description:
          "URL ยาว vCard ที่มีหลายช่อง และข้อความยาวทำให้โค้ดแน่น ควรลดข้อมูล ใช้ลิงก์สั้น หรือเลือก QR Code แบบไดนามิก"
      },
      {
        title: "ในรูปมี QR Code หลายอัน",
        description:
          "ตัดรูปให้เหลือโค้ดที่ต้องการ เครื่องมือจะแสดง QR Code แรกที่ตรวจพบ"
      },
      {
        title: "อ่าน URL ได้แต่เปิดหน้าปลายทางไม่ได้",
        description:
          "ตัว QR อาจยังปกติ ให้ตรวจอินเทอร์เน็ต สิทธิ์เข้าถึงไฟล์ การสะกด URL และดูว่าหน้าปลายทางยังเปิดใช้งานอยู่หรือไม่"
      }
    ]
  },
  safety: {
    eyebrow: "ตรวจสอบก่อนเชื่อถือ",
    title: "สแกนได้ไม่ได้แปลว่าปลายทางปลอดภัย",
    description:
      "ตรวจชื่อโดเมนก่อนกรอกรหัสผ่าน OTP หรือข้อมูลการชำระเงิน เพราะ QRCode GEN ไม่ได้ตรวจสอบความปลอดภัยของเว็บไซต์ปลายทาง",
    checks: [
      "อ่านชื่อโดเมนให้ครบและระวังตัวอักษรที่เลียนแบบชื่อแบรนด์",
      "อย่ากรอกรหัสผ่าน OTP หรือข้อมูลบัตรก่อนตรวจสอบเว็บไซต์",
      "อย่าติดตั้งไฟล์แอปจากนอกสโตร์อย่างเป็นทางการ",
      "การชำระเงินต้องตรวจชื่อผู้รับ ยอดเงิน และสกุลเงินในแอปธนาคารก่อนยืนยัน"
    ]
  },
  faq: {
    eyebrow: "คำถามที่พบบ่อย",
    title: "คำถามที่พบบ่อยเกี่ยวกับการสแกน QR Code ออนไลน์",
    items: [
      {
        q: "รูป QR Code ถูกส่งขึ้นเซิร์ฟเวอร์หรือไม่?",
        a: "ไม่ รูปถูกอ่านในเบราว์เซอร์บนอุปกรณ์โดยตรง QRCode GEN ไม่ต้องอัปโหลดไฟล์ไปยังเซิร์ฟเวอร์เพื่อถอดข้อมูล"
      },
      {
        q: "สแกน QR Code จากภาพหน้าจอได้ไหม?",
        a: "ได้ หากภาพคมชัดและเห็นโค้ดครบ ถ้าโค้ดเล็กมากให้ตัดรูปเข้าใกล้ขึ้น แต่ต้องเก็บขอบและพื้นที่ว่างรอบโค้ดไว้"
      },
      {
        q: "รองรับไฟล์รูปแบบใดบ้าง?",
        a: "รองรับ PNG, JPG, JPEG และ WebP ขนาดไม่เกิน 12 MB ส่วนไฟล์ HEIC ควรแปลงเป็น JPG หรือ PNG ก่อน"
      },
      {
        q: "ทำไมรูปดูชัดแต่ยังอ่านไม่ได้?",
        a: "พื้นที่ว่างอาจถูกตัด รูปอาจบิด สีต่างกันไม่พอ หรือข้อมูลแน่นเกินไปเมื่อเทียบกับขนาด ลองใช้ไฟล์ต้นฉบับหรือภาพที่มีความละเอียดสูงขึ้น"
      },
      {
        q: "ใช้เครื่องมือนี้สแกน QR ชำระเงินได้ไหม?",
        a: "เครื่องมืออาจแสดงข้อมูลที่เข้ารหัสได้ แต่ไม่ตรวจบัญชีผู้รับและไม่ทำรายการชำระเงิน โปรดสแกนซ้ำด้วยแอปธนาคารที่รองรับแล้วตรวจชื่อผู้รับกับยอดเงินก่อนยืนยัน"
      },
      {
        q: "อ่าน URL ได้แล้วแต่ทำไมลิงก์ไม่เปิด?",
        a: "เบราว์เซอร์อาจบล็อกแท็บใหม่ หรือหน้าปลายทางอาจต้องใช้อินเทอร์เน็ต การเข้าสู่ระบบ หรือสิทธิ์เข้าถึงไฟล์ ลองกดปุ่มเปิดลิงก์ในผลการสแกนอีกครั้ง"
      }
    ]
  },
  relatedTitle: "เนื้อหาที่เกี่ยวข้อง",
  relatedLinks: [
    { href: "/help", label: "แก้ปัญหาเมื่อกล้องอ่าน QR Code ไม่ได้" },
    { href: "/products/short-link", label: "ย่อลิงก์ยาวให้ QR Code สแกนง่ายขึ้น" },
    { href: "/products/custom-qr-code", label: "ปรับแต่ง QR Code โดยยังสแกนได้ชัด" },
    { href: "/what-is-qr-code", label: "QR Code ทำงานอย่างไร?" }
  ],
  cta: {
    title: "ต้องการสร้าง QR Code ใหม่?",
    description:
      "เลือกประเภทข้อมูล ตรวจรายละเอียด แล้วสร้างและดาวน์โหลด QR Code ได้ในเบราว์เซอร์",
    href: "/",
    label: "สร้าง QR Code ฟรี"
  }
};

export default th;
